module.exports = __webpack_public_path__ + "static/img/qrcode_android.6180649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr/qrcode_android.png
// module id = 322
// module chunks = 180